import * as Types from '../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type CreateProjectFolderMutationVariables = Types.Exact<{
  input: Types.CreateProjectFolderCommand;
}>;


export type CreateProjectFolderMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', create: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type CreateGroupedFolderForProjectMutationVariables = Types.Exact<{
  input: Types.CreateGroupedFolderForProjectCommand;
}>;


export type CreateGroupedFolderForProjectMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', createGroupedFolderForProject: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };

export type AddProjectToGroupedFolderMutationVariables = Types.Exact<{
  input: Types.AddProjectToGroupedFolderCommand;
}>;


export type AddProjectToGroupedFolderMutation = { __typename?: 'MutationModel', projectFolders: { __typename?: 'ProjectFoldersMutationModel', addProjectToGroupedFolder: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const CreateProjectFolderDocument = gql`
    mutation createProjectFolder($input: CreateProjectFolderCommand!) {
  projectFolders {
    create(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CreateProjectFolderMutationFn = Apollo.MutationFunction<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;

/**
 * __useCreateProjectFolderMutation__
 *
 * To run a mutation, you first call `useCreateProjectFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFolderMutation, { data, loading, error }] = useCreateProjectFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>(CreateProjectFolderDocument, options);
      }
export type CreateProjectFolderMutationHookResult = ReturnType<typeof useCreateProjectFolderMutation>;
export type CreateProjectFolderMutationResult = Apollo.MutationResult<CreateProjectFolderMutation>;
export type CreateProjectFolderMutationOptions = Apollo.BaseMutationOptions<CreateProjectFolderMutation, CreateProjectFolderMutationVariables>;
export const CreateGroupedFolderForProjectDocument = gql`
    mutation createGroupedFolderForProject($input: CreateGroupedFolderForProjectCommand!) {
  projectFolders {
    createGroupedFolderForProject(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type CreateGroupedFolderForProjectMutationFn = Apollo.MutationFunction<CreateGroupedFolderForProjectMutation, CreateGroupedFolderForProjectMutationVariables>;

/**
 * __useCreateGroupedFolderForProjectMutation__
 *
 * To run a mutation, you first call `useCreateGroupedFolderForProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupedFolderForProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupedFolderForProjectMutation, { data, loading, error }] = useCreateGroupedFolderForProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupedFolderForProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupedFolderForProjectMutation, CreateGroupedFolderForProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupedFolderForProjectMutation, CreateGroupedFolderForProjectMutationVariables>(CreateGroupedFolderForProjectDocument, options);
      }
export type CreateGroupedFolderForProjectMutationHookResult = ReturnType<typeof useCreateGroupedFolderForProjectMutation>;
export type CreateGroupedFolderForProjectMutationResult = Apollo.MutationResult<CreateGroupedFolderForProjectMutation>;
export type CreateGroupedFolderForProjectMutationOptions = Apollo.BaseMutationOptions<CreateGroupedFolderForProjectMutation, CreateGroupedFolderForProjectMutationVariables>;
export const AddProjectToGroupedFolderDocument = gql`
    mutation addProjectToGroupedFolder($input: AddProjectToGroupedFolderCommand!) {
  projectFolders {
    addProjectToGroupedFolder(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type AddProjectToGroupedFolderMutationFn = Apollo.MutationFunction<AddProjectToGroupedFolderMutation, AddProjectToGroupedFolderMutationVariables>;

/**
 * __useAddProjectToGroupedFolderMutation__
 *
 * To run a mutation, you first call `useAddProjectToGroupedFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectToGroupedFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectToGroupedFolderMutation, { data, loading, error }] = useAddProjectToGroupedFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectToGroupedFolderMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectToGroupedFolderMutation, AddProjectToGroupedFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectToGroupedFolderMutation, AddProjectToGroupedFolderMutationVariables>(AddProjectToGroupedFolderDocument, options);
      }
export type AddProjectToGroupedFolderMutationHookResult = ReturnType<typeof useAddProjectToGroupedFolderMutation>;
export type AddProjectToGroupedFolderMutationResult = Apollo.MutationResult<AddProjectToGroupedFolderMutation>;
export type AddProjectToGroupedFolderMutationOptions = Apollo.BaseMutationOptions<AddProjectToGroupedFolderMutation, AddProjectToGroupedFolderMutationVariables>;